// 散布図のレンダラー実装

import { GraphRenderer, ScatterPlotConfig, GraphCallbacks } from '../../../../types/graph-builder.types';
import { DataSet } from '../../../../types';
import { ScatterPlot } from '../../ScatterPlot';
import { getColumnById } from '../../../utils/column-utils';

export const scatterPlotRenderer: GraphRenderer<ScatterPlotConfig> = {
  validate(config: ScatterPlotConfig, dataset: DataSet): string | null {
    // データセットの検証
    if (!dataset || !dataset.schema || !dataset.schema.columns) {
      return 'Invalid dataset';
    }

    // X軸列の検証
    const xColumn = getColumnById(dataset, config.xColumn);
    if (!xColumn) {
      return `X-axis column "${config.xColumn}" not found in dataset`;
    }
    if (xColumn.type !== 'int64' && xColumn.type !== 'float64') {
      return `X-axis column "${xColumn.name}" must be numeric (found: ${xColumn.type})`;
    }

    // Y軸列の検証
    const yColumn = getColumnById(dataset, config.yColumn);
    if (!yColumn) {
      return `Y-axis column "${config.yColumn}" not found in dataset`;
    }
    if (yColumn.type !== 'int64' && yColumn.type !== 'float64') {
      return `Y-axis column "${yColumn.name}" must be numeric (found: ${yColumn.type})`;
    }

    // 色分け列の検証（オプション）
    if (config.colorColumn) {
      const colorColumn = getColumnById(dataset, config.colorColumn);
      if (!colorColumn) {
        return `Color column "${config.colorColumn}" not found in dataset`;
      }
      // カテゴリカル列の場合、ユニーク値が多すぎないかチェック
      // TODO: 実装
    }

    // サイズ列の検証（オプション）
    if (config.sizeColumn) {
      const sizeColumn = getColumnById(dataset, config.sizeColumn);
      if (!sizeColumn) {
        return `Size column "${config.sizeColumn}" not found in dataset`;
      }
      if (sizeColumn.type !== 'int64' && sizeColumn.type !== 'float64') {
        return `Size column "${sizeColumn.name}" must be numeric (found: ${sizeColumn.type})`;
      }
    }

    return null;
  },

  render(config: ScatterPlotConfig, dataset: DataSet, callbacks: GraphCallbacks) {
    const xColumn = getColumnById(dataset, config.xColumn);
    const yColumn = getColumnById(dataset, config.yColumn);
    
    if (!xColumn || !yColumn) {
      return <div>Error: Column not found</div>;
    }


    // onPointClickハンドラーを作成
    const handlePointClick = callbacks.onElementSelect 
      ? (dataIndices: number[], isAdditive?: boolean) => {
          callbacks.onElementSelect!(dataIndices, isAdditive || false);
        }
      : undefined;

    return (
      <div style={{ width: '100%', height: '100%' }}>
        <ScatterPlot
          dataset={dataset}
          xColumn={config.xColumn}
          yColumn={config.yColumn}
          colorColumn={config.colorColumn}
          selectedRows={callbacks.selectedRows}
          onPointClick={handlePointClick}
          width={undefined} // コンテナに合わせて自動調整
          height={undefined} // コンテナに合わせて自動調整
          referenceLines={config.referenceLines}
          displayMode={config.displayMode}
          densityVisualization={config.densityVisualization}
          densityBandwidth={config.densityBandwidth}
          contourLevels={config.contourLevels}
          densityColorScale={config.densityColorScale}
        />
      </div>
    );
  }
};